import { TooltipParagraph } from "components/tooltipParagraph";
import { IParticipantInfo } from "interfaces";
import { abbreviateNumbers, formatNumber } from "utills/helpers";

interface ParticipantsInfoTableProps {
  data?: IParticipantInfo[];
  pageSize: number;
  currentPage: number;
  isLoading: boolean;
}

export const ParticipantsInfoTable = ({data = [], isLoading, currentPage, pageSize }: ParticipantsInfoTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th
                scope="col"
                className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8"
              >
                No
              </th>
              <th scope="col" className="th">
                Category
              </th>
              <th scope="col" className="th">
                Quantity
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
          {(!isLoading) ? data.map((item: IParticipantInfo, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td max-w-10 overflow-x-auto">
                  <TooltipParagraph 
                    text={item.category_name_en}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.quantity)}
                  >
                    {abbreviateNumbers(item.quantity)}
                  </span>
                </td>
              </tr>
            )) 
            : Array(10).fill(null).map((item: any, index: number) => (
              <tr key={index} className="h-[57px]">
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td max-w-40 overflow-x-auto">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
              </tr>
            ))}
            {data.length === 0 && !isLoading ? (
              <tr>
                <td colSpan={10} className="td">
                  <div className="text-center">
                    No data
                  </div>
                </td>
              </tr>
            ) : <></>}
          </tbody>
        </table>
      </div>

    </div>

  )
}